import React, { HTMLAttributes } from 'react';
import { observer } from 'mobx-react-lite';
import { StyledMultiSelect} from './category-multi-select.styled';

export type Props = {
    isSelected: boolean;
    isDisabled?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const CategoryMultiSelect = observer(({ children, ...props }: Props) => {
    return <StyledMultiSelect {...props}>{children}</StyledMultiSelect>;
});